// extracted by mini-css-extract-plugin
export var specFieldValue = "spec-list-module--spec-field-value--d+iIA";
export var markdownImage = "spec-list-module--markdown-image--f8qMW";